import React, { useEffect, useState, useCallback } from "react";
import {
  Col,
  Row,
  Card,
  CardBody,
  Button,
  InputGroup,
  Input,
  DropdownToggle,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Container,
  InputGroupText,
} from "reactstrap";
import DataTable from "react-data-table-component";
import { Link } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import DeleteModal from "../../../Components/Common/DeleteModal";
import CostCenterService from "../../../services/OrderingServices/CostCenterService";

import CostCenterForm from "../component/CostCenterForm";
import useIsSmallScreen from "../../Payment Type/Component/small screen/SmallScreen";

import useTableSearch from "../../../hooks/useTableSearch";
import TableSearch from "../../../Components/Common/TableSearch";
const customStyles = {
  headCells: {
    style: {
      fontSize: "0.92rem",
      fontWeight: 610,
    },
  },
  rows: {
    style: {
      fontSize: "0.9rem",
    },
  },
};

const CostCenter = () => {
  const [costCenter, setCostCenter] = useState([]);
  const [loading, setLoading] = useState(false);
  const [addModal, setAddModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const navigate = useNavigate();
  const [deleteModal, setDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const isSmallScreen = useIsSmallScreen();

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => (currentPage - 1) * rowsPerPage + (index + 1),
      width: "75px",
    },
    {
      name: "Name",
      selector: (row) => `${row.name}`,
      cell: (row) => row.name,
      sortable: true,
    },
    {
      name: "Printer Name",
      selector: (row) => row.printerName,
      sortable: true,
    },

    {
      name: "Ip Address",
      selector: (row) => row.printerIpAddress,
      sortable: true,
    },
    {
      name: "Printer Port",
      selector: (row) => row.printerPort,
      sortable: true,
      right: true,
    },
    {
      name: "Printer Type",
      selector: (row) => row.printerType,
      sortable: true,
      right: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div>
          {/* <Link to={`/cost-center/${row.id}`}>
            <Button color="btn btn-soft-success" className="btn-sm">
              <i className="bx bx-show" />
            </Button>
          </Link> */}
          <Button
            color="btn btn-soft-warning"
            className="btn-sm ms-1"
            onClick={() => {
              setAddModal(true);
              setSelectedItem(row);
            }}
          >
            <i className="ri-edit-line" />
          </Button>
          <Button
            className="btn btn-soft-danger btn-sm ms-1"
            color="danger"
            onClick={() => handleDeleteClick(row.id)}
          >
            <i className="ri-delete-bin-5-line" />
          </Button>
        </div>
      ),
      center: true,
    },
  ];

  const { searchTerm, setSearchTerm, filteredData } = useTableSearch(
    costCenter,
    ["name", "printerName", "printerIpAddress", "printerPort", "printerType"]
  );

  const fetchCostCenter = async () => {
    try {
      setLoading(true);
      const response = await CostCenterService.getList();

      setCostCenter(response);

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("🚀 ~ error:", error);
    }
  };

  // Fetch customers when debounced filters, current page or page size changes
  useEffect(() => {
    fetchCostCenter();
  }, []);
  const [filterText, setFilterText] = useState("");

  const handleFilterChange = (e) => {
    setFilterText(e.target.value);
  };

  const toggleDeleteModal = () => setDeleteModal(!deleteModal);
  const handleDeleteClick = (item) => {
    setSelectedItem(item);
    toggleDeleteModal();
  };
  const handleDelete = async () => {
    if (selectedItem) {
      try {
        await CostCenterService.delete(selectedItem);
        setCostCenter((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedItem)
        );
        toast.success("Selected cost center deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the record");
      } finally {
        toggleDeleteModal();
        setSelectedItem(null);
      }
    }
  };
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb title="Cost Center" pageTitle="System Setup" />

        <div
          className="p-3 p-lg-4 mt-1"
          style={{
            background: "#fff",
            borderRadius: "0.5rem",
            boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
            border: "1px solid #eee",
          }}
        >
          {/* Filter Button */}
          <Row className="justify-content-between align-content-center align-items-center ">
            <Col md={6} className="align-items-center">
              <h5 className="mb-1 fw-bold text-dark ">Cost Centers List</h5>
            </Col>
            <Col md={6} className="mb-3">
              <div className="d-flex justify-content-end align-content-center align-items-center gap-3">
                <div className="d-flex align-items-center justify-content-end">
                  <TableSearch
                    value={searchTerm}
                    onChange={setSearchTerm}
                    placeholder="Search by all.."
                  />
                </div>
                <Button
                  color="success"
                  onClick={() => setAddModal(true)}
                  className="d-flex align-items-center gap-2"
                  style={{ borderRadius: "8px" }}
                >
                  <i className="bx bx-plus"></i> Add
                </Button>
              </div>
            </Col>
            {/* </div> */}
          </Row>

          {isSmallScreen ? (
            loading ? (
              <div className="d-flex justify-content-center my-3">
                <Triangle
                  visible={true}
                  height="80"
                  width="80"
                  color="#5B71B9"
                />
              </div>
            ) : (
              <>
                {filteredData?.map((item, index) => (
                  <Card
                    key={item?.id || index}
                    className="mb-3 shadow-sm d-block d-lg-none"
                  >
                    <CardBody>
                      <Row>
                        <Col xs={10} className="pt-2">
                          <h6 className="mb-2">{item?.name}</h6>
                          <h6 className="mb-2 text-muted">
                            Printer Type: {item?.printerType}
                          </h6>
                          <h6 className="mb-2 text-muted">
                            Printer Name: {item?.printerName}
                          </h6>
                          <h6 className="mb-2 text-muted">
                            Ip Address: {item?.printerIpAddress}
                          </h6>
                          <h6 className="mb-2 text-muted">
                            Printer Port: {item?.printerPort}
                          </h6>
                          <h6 className="mb-2 text-muted">
                            {item?.description || "N/A"}
                          </h6>
                          <span
                            className={`badge ${
                              item.isActive ? "bg-success" : "bg-danger"
                            }`}
                          >
                            {item.isActive ? "Active" : "Inactive"}
                          </span>{" "}
                        </Col>
                        <Col xs={2}>
                          <Dropdown
                            isOpen={item.dropdownOpen || false}
                            toggle={(e) => {
                              e.stopPropagation();
                              setCostCenter((prev) =>
                                prev.map((costCenter) =>
                                  costCenter.id === item.id
                                    ? {
                                        ...costCenter,
                                        dropdownOpen: !costCenter.dropdownOpen,
                                      }
                                    : { ...costCenter, dropdownOpen: false }
                                )
                              );
                            }}
                            direction="down"
                          >
                            <DropdownToggle
                              color="primary"
                              outline
                              className="btn-sm shadow-sm rounded-circle"
                            >
                              <i className="ri-more-2-fill"></i>
                            </DropdownToggle>
                            <DropdownMenu end>
                              <DropdownItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setAddModal(true);
                                  setSelectedItem(item);
                                }}
                              >
                                <i className="ri-edit-line text-warning me-2"></i>{" "}
                                Edit
                              </DropdownItem>
                              <DropdownItem
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDeleteClick(item.id);
                                }}
                              >
                                <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                                Delete
                              </DropdownItem>
                            </DropdownMenu>
                          </Dropdown>
                        </Col>
                      </Row>
                    </CardBody>
                  </Card>
                ))}
              </>
            )
          ) : (
            <CustomDataTable
              responsive
              striped
              pagination
              onChangePage={(page) => setCurrentPage(page)}
              onChangeRowsPerPage={(newPerPage) => {
                setRowsPerPage(newPerPage);
                setCurrentPage(1);
              }}
              fixedHeader
              persistTableHead
              progressPending={loading}
              customStyles={customStyles}
              progressComponent={
                <div className="my-3 text-center">
                  <Triangle
                    visible={true}
                    height="80"
                    width="80"
                    color="#5B71B9"
                  />
                  <h5 className="mt-1">Loading...</h5>
                </div>
              }
              columns={columns}
              data={filteredData}
              noDataComponent={
                <div className="text-center my-5 w-100">
                  <i className="ri-emotion-unhappy-line display-4 text-secondary" />
                  <h5 className="fw-semibold text-secondary">
                    No data Available
                  </h5>
                  <p className="text-muted mb-0">No recipes found.</p>
                </div>
              }
            />
          )}
        </div>
        <CostCenterForm
          modal={addModal}
          toggleModal={() => {
            setAddModal(false);
            setSelectedItem(null); // Clear editing state when closing
          }}
          setCostCenter={setCostCenter}
          costCenter={costCenter}
          selectedItem={selectedItem}
          fetchCostCenter={fetchCostCenter}
        />
        <DeleteModal
          show={deleteModal}
          onDeleteClick={handleDelete}
          onCloseClick={toggleDeleteModal}
          selectedItem={selectedItem} // Pass the selected item
        />
      </div>
      <div className="d-block d-md-none">
        {filteredData?.map((item, index) => (
          <Card
            key={item?.id || index}
            className="mb-3 shadow-sm d-block d-lg-none"
          >
            <CardBody>
              <Row>
                <Col xs={10} className="pt-2">
                  <h6 className="mb-2">{item?.name}</h6>
                  <h6 className="mb-2 text-muted">
                    Printer Type: {item?.printerType}
                  </h6>
                  <h6 className="mb-2 text-muted">
                    Printer Name: {item?.printerName}
                  </h6>
                  <h6 className="mb-2 text-muted">
                    Ip Address: {item?.printerIpAddress}
                  </h6>
                  <h6 className="mb-2 text-muted">
                    Printer Port: {item?.printerPort}
                  </h6>
                  <h6 className="mb-2 text-muted">
                    {item?.description || "N/A"}
                  </h6>
                  <span
                    className={`badge ${
                      item.isActive ? "bg-success" : "bg-danger"
                    }`}
                  >
                    {item.isActive ? "Active" : "Inactive"}
                  </span>{" "}
                </Col>
                <Col xs={2}>
                  <Dropdown
                    isOpen={item.dropdownOpen || false}
                    toggle={(e) => {
                      e.stopPropagation();
                      setCostCenter((prev) =>
                        prev.map((costCenter) =>
                          costCenter.id === item.id
                            ? {
                                ...costCenter,
                                dropdownOpen: !costCenter.dropdownOpen,
                              }
                            : { ...costCenter, dropdownOpen: false }
                        )
                      );
                    }}
                    direction="down"
                  >
                    <DropdownToggle
                      color="primary"
                      outline
                      className="btn-sm shadow-sm rounded-circle"
                    >
                      <i className="ri-more-2-fill"></i>
                    </DropdownToggle>
                    <DropdownMenu end>
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          setAddModal(true);
                          setSelectedItem(item);
                        }}
                      >
                        <i className="ri-edit-line text-warning me-2"></i> Edit
                      </DropdownItem>
                      <DropdownItem
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick(item.id);
                        }}
                      >
                        <i className="ri-delete-bin-5-line text-danger me-2"></i>{" "}
                        Delete
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </Col>
              </Row>
            </CardBody>
          </Card>
        ))}
      </div>
    </Container>
  );
};

export default CostCenter;
